import CirclePlusIcon from '../../../../icons/CirclePlus.svg';
import * as translator from '../../../../utils/translator';

type AddNewAddressCardProps = {
    language: string;
    onClick: () => void;
};

const AddNewAddressCard: React.FC<AddNewAddressCardProps> = ({
    language,
    onClick
}) => {
    return (
        <>
            <div
                id='add-new-address-card'
                onClick={onClick}
                className="max-h-[300px] min-h-[300px] rounded-lg border border-gray-200 bg-white shadow-sm flex flex-col items-center justify-center p-8 cursor-pointer hover:border-gray-300 transition-colors h-full"
            >
                <img id='add-new-address-card-icon' className='w-[20px] h-[20px] object-cover' src={CirclePlusIcon} alt="Add" />
                <span className="text-[#0D2C54] text-xs">{translator.translate(language, "my_account", `DeliveryAddressV2/addNewAddress`)}</span>
            </div>
        </>
    );
};

export default AddNewAddressCard;